import { SortableElement } from 'react-sortable-hoc'

const SortableItem = SortableElement(({ value }) => value)

export default SortableItem
